/* eslint-disable no-param-reassign, import/prefer-default-export */
import * as actions from 'modules/app-core/notification-manager/actions'
import isUndefined from 'lodash/isUndefined'
import userSession from 'store/modules/user-session'

export const preserveRedirectSearch = () => (next) => (action) => {
  if (action.type === 'SAVE_REDIRECT_ROUTE' && window.location.search) {
    const search = window.location.search.slice(1)
    const separator = action.route.includes('?') ? '&' : '?'
    return next({ ...action, route: `${action.route}${separator}${search}` })
  }
  return next(action)
}

/**
 * On re-login only: restore userSession.currentUrl after a successful login request.
 * Deferred so auth-ui can apply a pre-login deep-link redirectRoute first.
 */
export const restoreUrlAfterLogin = (store) => (next) => (action) => {
  const result = next(action)
  if (
    action.type === 'authui/REQUEST_SUCCESS' &&
    action.payload?.name === 'login'
  ) {
    setTimeout(() => {
      store.dispatch(userSession.actions.restoreCurrentUrl())
    }, 0)
  }
  return result
}

export const hixmeNotifications = (store) => (next) => (action) => {
  if (action.notification) {
    if (isUndefined(action.notification.autoClose)) {
      action.notification.autoClose = true
    }
    store.dispatch(actions.createNotification(action.notification))
  }

  const result = next(action)
  return result
}

export const dispatchEvents = (emitter) => (store) => (next) => (action) => {
  const result = next(action)
  if (action.type) {
    emitter.emit(action.type, action, store)
  }
  return result
}
